/* eslint no-restricted-globals:0 */
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { 
  AppBar,
  Toolbar,
  Button,
  Hidden,
  IconButton
} from '@material-ui/core';
import MailOutlineRoundedIcon from '@material-ui/icons/MailOutlineRounded';

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    backgroundColor: '#FFF',
    width: '100%',
    overflow: 'hidden'
  },
  root2: {
    boxShadow: 'none',
    backgroundColor: '#FFF',
    borderBottom: '4px #0E419C solid',
    paddingTop: '8px'
  },
  flexGrow: {
    flexGrow: 1
  },
  img_size: {
    [theme.breakpoints.down('md')]: {
      width: '200px'
    },
    [theme.breakpoints.up('md')]:{
      maxHeight: '80px'
    }
  },
  button: {
    margin: theme.spacing(1),
  }
}));


const Topbar = props => {

  const { className, onClick, login_name, location, ...rest } = props;
  const classes = useStyles();


  const contact = () => {
    window.location.href="mailto:sales-information@connectcompass.net?subject=【CONNECTCOMPASS】お問い合わせ&amp;body="
  }



  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}>
      <Toolbar className={clsx(classes.root2, className)}>
        <div style={{width: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
          <div align="left" style={{float: "left", width: "50%"}}>          
            <img src={`${process.env.PUBLIC_URL}/cclogo.png`} alt="" className={classes.img_size} />
          </div>
          <div align="right" style={{width: "50%"}}>
            <Hidden smUp>
            <IconButton color="primary" aria-label="upload picture" component="span">
            <MailOutlineRoundedIcon onClick={contact} />
            </IconButton>
            </Hidden>
            <Hidden xsDown>
              <Button
                variant="outlined"
                color="primary"
                className={classes.button}
                startIcon={<MailOutlineRoundedIcon color="primary"/>}
                onClick={contact}
              >
                お問い合わせ
              </Button>
            </Hidden>
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
}

  Topbar.propTypes = {
    className: PropTypes.string,
  }

export default Topbar;